import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import logo from '../assets/img/logo.svg';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/github (2).svg';




export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
        
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }


    return(

    <Navbar expand="lg" className={scrolled ? "scrolled":""}>
      <Container>
        {/* <Navbar.Brand href="#home">
            <img src={logo} alt="logo" className="logo" />
        </Navbar.Brand> */}

        <Navbar.Toggle aria-controls="basic-navbar-nav" >
            <span className="navbar-toggler-icon"></span>
         </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home" className={activeLink==='home'? 'active navbar-link':'navbar-link'} onClick={()=>onUpdateActiveLink('home')}>HOME</Nav.Link>
            <Nav.Link href="#skill" className={activeLink==='skills'? 'active navbar-link':'navbar-link'} onClick={()=>onUpdateActiveLink('skill')}>SKILLS</Nav.Link>
            <Nav.Link href="#project" className={activeLink==='projects'? 'active navbar-link':'navbar-link'} onClick={()=>onUpdateActiveLink('project')}>PROJECTS</Nav.Link>  
          </Nav>

         <span className="navbar-text">
            <div className="social-icon">
                <a href="https://www.linkedin.com/in/nimesh-kavinda-k0000/"><img src={navIcon1}/></a>
                <a href="https://www.facebook.com/nimesh.liyanage.7140"><img src={navIcon2}/></a>
                <a href="https://instagram.com/_nime_sh_?igshid=MzNlNGNkZWQ4Mg=="><img src={navIcon3}/></a>
                <a href="https://github.com/nimeshkk"><img src={navIcon4}/></a>
            </div>
            {/* <button className="btn" onClick={()=>console.log('connect')}><span>Let's connect</span></button> */}
         </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
 


    )
};
